import axios from "axios";
import { resizeImageFile } from "./imageResize";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("vastrakiran_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  if (config.data instanceof FormData) {
    delete config.headers["Content-Type"];
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url || "";
    const isAuthRoute = url.includes("/auth/login") || url.includes("/auth/register-tenant");
    if (status === 401 && !isAuthRoute) {
      localStorage.removeItem("vastrakiran_token");
      if (!window.location.pathname.startsWith("/login") && !window.location.pathname.startsWith("/register")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export const rupee = (n) =>
  "\u20B9" + (Number(n) || 0).toLocaleString("en-IN", { maximumFractionDigits: 2, minimumFractionDigits: 2 });

export const MAX_IMAGE_BYTES = 1 * 1024 * 1024;

function formatMb(bytes) {
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

/** Upload a single image file; returns the stored URL path from the API. */
export async function uploadImageFile(file) {
  if (!file?.size) {
    throw new Error("No image selected");
  }

  const prepared = await resizeImageFile(file, undefined, MAX_IMAGE_BYTES);

  if (prepared.size > MAX_IMAGE_BYTES) {
    throw new Error(`Image is ${formatMb(prepared.size)} after resize — maximum allowed is ${formatMb(MAX_IMAGE_BYTES)}`);
  }

  const fd = new FormData();
  fd.append("image", prepared, prepared.name);
  const { data } = await api.post("/upload/image", fd);
  return data.url;
}

/** Upload multiple image files; returns stored URL paths. */
export async function uploadImageFiles(files, max = 5) {
  const urls = [];
  for (const file of files.slice(0, max)) {
    urls.push(await uploadImageFile(file));
  }
  return urls;
}

/** Turn API upload path into a full browser URL (served from XAMPP, not the CRA dev server). */
export const imageUrl = (path) => {
  if (!path) return "";
  if (path.startsWith("http://") || path.startsWith("https://")) return path;
  const rel = path.startsWith("/") ? path : `/${path}`;
  try {
    const backend = new URL(BACKEND_URL);
    return `${backend.origin}${rel}`;
  } catch {
    const origin = typeof window !== "undefined" ? window.location.origin : "";
    return `${origin}${rel}`;
  }
};
